import { LoaderFunctionArgs, isRouteErrorResponse, useRouteError } from "react-router-dom";
import Result from "antd/es/result";
import { Button } from "antd";
import type { UnitListingDetails } from "~/types/listing";
import { ROUTES } from "~/utils";
import { loadListingDetails } from "../../loadListingDetails";

export const UnitDetailsPageLoader = async ({
  request,
  params,
}: LoaderFunctionArgs) => {
  const unitID = params.unitID ?? "";
  const details = await loadListingDetails(request, "unit", unitID);
  if (details instanceof Response) {
    return details;
  }
  if (details.kind !== "unit") {
    throw new Response("Invalid listing kind", { status: 500 });
  }
  return details as UnitListingDetails;
};

export type UnitDetailsPageLoaderType = UnitListingDetails;

export const UnitDetailsPageErrorBoundary = () => {
  const routeError = useRouteError();
  const subTitle = isRouteErrorResponse(routeError)
    ? typeof routeError.data === "string"
      ? routeError.data
      : "This listing is not available."
    : "This listing is not available.";

  const statusCode = isRouteErrorResponse(routeError) ? routeError.status : 404;

  return (
    <Result
      status={statusCode === 404 ? 404 : "error"}
      title={String(statusCode)}
      subTitle={subTitle}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button type="primary" href={ROUTES.unit}>
          Back to listings
        </Button>
      </div>
    </Result>
  );
};
